module.exports = __webpack_public_path__ + "static/media/welded100x100.c875a753.PNG";